import React, { useContext, useEffect, useMemo, useState } from 'react'

import { selectLoggedIn as isLoggedInSelector } from 'selectors/accountSelectors'
import { useAppSelector } from 'hooks/reduxHooks'
import AccountAccessModal from 'components/Account/AccountAccess/AccountAccessModal'
import MasterModalContext from 'contexts/MasterModalContext'
import ModalContext from 'contexts/ModalContext'
import { matchPath } from 'react-router'
import { isPaidSessionSelector } from 'selectors/marketingSelectors'

const ShowLoginExcludedRoutes = [
  '/:regionCode/pay/:paymentLinkId',
  '/:regionCode/offer',
  '/:regionCode/tour',
  '/:regionCode/cruises',
  '/:regionCode/experience',
  '/:regionCode/partner',
  '/:regionCode/metasearch/:propertyId',
  '/:regionCode/business-signup',
  '/:regionCode/business-signup-complete',
  '/:regionCode/business-traveller/business-signup',
  '/:regionCode/employee-setup',
  '/:regionCode/frequently-asked-questions',
  '/:regionCode/terms-and-conditions',
  '/:regionCode/privacy-policy',
  '/:regionCode/expression-of-interest',
]

export const MODAL_OPENED_TIMEOUT_IN_SECONDS = 10

function useShowLogin() {
  const [hasShownThisAnonSession, setHasShownThisAnonSession] = useState<boolean>(false)
  const isLoggedIn = useAppSelector(isLoggedInSelector)
  const showModal = useContext(ModalContext)
  const modalState = useContext(MasterModalContext)
  const isPaidSession = useAppSelector(isPaidSessionSelector)

  const currentPath = useAppSelector(state => state.router.location.pathname)
  const isBlacklistedRoute = useMemo(() => {
    return !!matchPath(currentPath, { path: ShowLoginExcludedRoutes, exact: false })
  }, [currentPath])

  // reset the session flag when the user logs in, otherwise the modal will not show again
  useEffect(() => {
    if (isLoggedIn && hasShownThisAnonSession) {
      setHasShownThisAnonSession(false)
    }
  }, [isLoggedIn, hasShownThisAnonSession])

  useEffect(() => {
    if (!isLoggedIn && !hasShownThisAnonSession && !modalState.open && !isPaidSession && !isBlacklistedRoute) {
      setHasShownThisAnonSession(true) // set the flag to true to prevent the modal from showing again
      showModal(<AccountAccessModal />)
    }
  }, [hasShownThisAnonSession, isLoggedIn, showModal, modalState, isPaidSession, isBlacklistedRoute])
}

export default useShowLogin
